import { decryptCustomerId } from "@amzn/amazon-id";

import { isProdStage } from "./stageUtils";

/**
 * Selection Central deep links, for remediating catalog issues.
 *
 * The host is stage aware: outside production we must point at the Selection
 * Central integ stack, otherwise a local or beta session sends the user to
 * production data. This mirrors the long standing behaviour in
 * `features/common/AsinDisplayCell.tsx`.
 *
 * Selection Central keys items by the NUMERIC marketplace id, while this
 * application carries the obfuscated form, so callers that only hold the
 * obfuscated id should use `selectionCentralUrlForObfuscatedMarketplace`.
 */
export function selectionCentralUrl(
  asin: string,
  marketplaceId: string
): string {
  const host = isProdStage()
    ? "selection.amazon.com"
    : "selection-beta.integ.amazon.com";
  return `https://${host}/item/${marketplaceId}/${asin}/issues`;
}

/**
 * As `selectionCentralUrl`, but decrypts the obfuscated marketplace id first.
 * Returns `undefined` when the id cannot be decrypted, so callers can render
 * plain text instead of a broken link rather than throwing inside a table cell.
 */
export function selectionCentralUrlForObfuscatedMarketplace(
  asin: string,
  obfuscatedMarketplaceId: string
): string | undefined {
  try {
    const marketplaceId = decryptCustomerId(obfuscatedMarketplaceId);
    if (!marketplaceId) {
      return undefined;
    }
    return selectionCentralUrl(asin, String(marketplaceId));
  } catch {
    return undefined;
  }
}
